// extracted by mini-css-extract-plugin
export default {"container":"Imprint_container__N5o0B"};